import { Button } from '@moniebook-web/components/atoms/button';
import { StructuredModal } from '@moniebook-web/components/atoms/structured-modal';
import { mergeClassNames } from '@moniebook-web/utils';
import { type AlertProps } from '@register-ui/utils';

interface AlertModalProps extends AlertProps {
    open: boolean;
}

const DEFAULT_MESSAGE =
    'You are about to delete this item. This action cannot be undone.';

export function AlertModal(props: Readonly<AlertModalProps>) {
    const {
        open,
        onClose,
        onConfirm,
        title,
        message = DEFAULT_MESSAGE,
        confirmText = 'Delete item',
        cancelText = 'Never mind',
        cancelTheme = 'secondary',
        confirmTheme = 'danger',
        disableConfirm,
        showCancelButton = true,
        secondaryActionText,
        secondaryActionTheme = 'secondary',
        secondaryActionClassName,
        onSecondaryAction,
    } = props;

    return (
        <StructuredModal.Modal isOpen={open} onClose={onClose}>
            <StructuredModal.Header>
                <StructuredModal.Title>{title}</StructuredModal.Title>
            </StructuredModal.Header>

            <StructuredModal.Body>
                <p>{message}</p>
            </StructuredModal.Body>

            <StructuredModal.Footer>
                {showCancelButton && (
                    <Button
                        onClick={onClose}
                        theme={cancelTheme}
                        label={cancelText}
                        className='w-full'
                    />
                )}
                {onSecondaryAction && (
                    <Button
                        onClick={onSecondaryAction}
                        theme={secondaryActionTheme}
                        label={secondaryActionText}
                        className={mergeClassNames(
                            'w-full',
                            secondaryActionClassName,
                        )}
                    />
                )}
                <Button
                    onClick={onConfirm}
                    theme={confirmTheme}
                    label={confirmText}
                    disabled={disableConfirm}
                    className='w-full'
                />
            </StructuredModal.Footer>
        </StructuredModal.Modal>
    );
}
